import axios from 'axios';
import api from '../../../utils/api';
import {
  CUSTOMER_MEETING_PLANNER,
  MEETING_SPONSORS,
  MEETING_PLANNER_MEETINGS,
  AVAILABLE_SLOTS_MODAL_ID,
  // ACCEPT_INVITATION,
  // REFUSE_INVITATION,
} from './types';

export default {
  setAvailableSlotsModalId({ commit }, id) {
    commit(AVAILABLE_SLOTS_MODAL_ID, { id });
  },
  async fetchMeetings({ commit }, mpData) {
    const { data } = await axios(api.meetings.customerMeetingPlanner(mpData));
    commit(MEETING_PLANNER_MEETINGS, { meetings: data });
    return data;
  },
  async fetchMeetingPlanner({ commit }, event) {
    const response = await axios(api.meetings.getMeetingPlanner(event));
    commit(CUSTOMER_MEETING_PLANNER, { mpSlots: response.data.result });
    return response.data.result;
  },
  async meetingPlannerInvitation(_, invitationData) {
    const { data } = await axios(
      api.meetings.meetingPlannerInvitation(invitationData),
    );
    return data;
  },

  async acceptOrRefuseInvitation(_, { invitationResponse }) {
    const data = await axios(
      api.meetings.acceptOrRefuseInvitation(invitationResponse),
    );

    return data;
  },
  // async acceptOrRefuseInvitation({ commit }, {
  //   invitationResponse, dayIndex, startTime, endTime, invitationIndex,
  // }) {
  //   const data = await axios(api.meetings.acceptOrRefuseInvitation(invitationResponse));

  //   if (invitationResponse.approved) {
  //     commit(ACCEPT_INVITATION, {
  //       dayIndex, startTime, endTime, invitationIndex,
  //     });
  //   } else {
  //     commit(REFUSE_INVITATION, {
  //       dayIndex, startTime, endTime, invitationIndex,
  //     });
  //   }
  //   return data;
  // },
  async meetingPlannerSlotBlock(_, reqData) {
    const { data } = await axios(api.meetings.meetingPlannerSlotBlock(reqData));
    return data;
  },
  async meetingPlannerSlotUnblock(_, id) {
    const data = await axios(api.meetings.meetingPlannerSlotUnblock(id));
    return data;
  },
  async editMeeting(_, editData) {
    const data = await axios(api.meetings.editMeeting(editData));
    return data;
  },
  async cancelMeetingInvitation(_, reqData) {
    const data = await axios(api.meetings.cancelMeetingInvitation(reqData));
    return data;
  },
  async fetchSingleMPInvitation(_, invitationId) {
    const { data } = await axios(
      api.meetings.fetchSingleMPInvitation(invitationId),
    );
    return data;
  },
  async deleteMeeting(_, meetingId) {
    const { data } = await axios(api.meetings.deleteMeeting(meetingId));
    return data;
  },
  async getMeetingSponsors({ commit }, eventId) {
    const { data } = await axios(api.meetings.getMeetingSponsors(eventId));
    commit(MEETING_SPONSORS, { data });
    return data;
  },
};
